function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "p3lsq7wwma"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon-arrow-right-small-mono (Background/Mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon-arrow-right-small-mono (Background/Mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#p3lsq7wwma)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.262 10.532a.9.9 0 0 1 0-1.27l3.87-3.87-3.87-3.86a.9.9 0 0 1 1.27-1.27l4.5 4.5a.9.9 0 0 1 0 1.27l-4.5 4.5a.894.894 0 0 1-.63.26.935.935 0 0 1-.64-.26z",
    transform: "translate(4.848 2.608)",
    style: {
      fill: "#777"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMore);
export default __webpack_public_path__ + "static/media/ico_more.6d2a9d341f551d7782824c39e2882658.svg";
export { ForwardRef as ReactComponent };